import { getAuthAppPusher } from 'services/common/common.service';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IPusherConfig } from 'services/common/types';

export const ThunkGetAuthAppClient = createAsyncThunk<IPusherConfig>(
  'common/getAuthAppPusher',
  () => getAuthAppPusher().then(r => r.data),
);
